/**
 * Communication Matrix API Endpoints
 * Framework-agnostic endpoint definitions for the communication module
 * (Messages & Takeovers, Push Notifications, etc.)
 * All endpoints require the program_id query parameter where applicable.
 */

export const COMMUNICATION_MATRIX_ENDPOINTS = {
  /** List all communications - ?program_id=1&status=0 */
  list: 'communication/list',

  /** Create a new communication (message / takeover) */
  create: 'communication/create',

  /** Update an existing communication */
  update: 'communication/update',

  /** Get a single communication for prefill - ?id=1 */
  view: 'communication/view',

  /** Activate / deactivate a communication - POST { id, status } */
  changeStatus: 'communication/change-status',
} as const;
